/**
 * Returns `true` if both arguments are `true`; `false` otherwise.
 * @since v0.1.0
 * @param  a
 * @param  b
 * @return  the first argument if it is falsy, otherwise the second argument.
 */
const or=(a, b):boolean =>a || b;
export default or;


// WEBPACK FOOTER //
// ./src/or.ts